export default function getResource(label, vars = []) {
    const resources = {
        title: 'Activité liée aux points',
        backLink: 'Retour à Beauty Insider',
        viewMoreTransactionsText: 'Voir plus de transactions',
        recentRecordsText: `Seules vos actions ${vars[0]} les plus récentes sont affichées.`,
        noPoints: 'Votre activité liée aux points s’affichera ici.',
        doNotSeePoints: 'Vous ne voyez toujours pas vos points? Votre activité sera mise à jour dans les 24 heures.',
        errorLoadingPoints: 'Nous ne pouvons pas charger votre activité liée aux points pour le moment. Veuillez réessayer plus tard.',
        retry: 'Réessayer'
    };

    return resources[label];
}
